var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-4 pr-1 custom-container",staticStyle:{"width":"100%"}},[_c('v-row',{attrs:{"dense":"","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('Table',{key:_vm.tableKey,attrs:{"items":_vm.histories,"loading":_vm.loading},on:{"fetchHistories":function($event){return _vm.fetchHistories($event)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }